import React from 'react'

export default function News() {
  return (
    <>
    <div className=' ml-0 mr-0 pr-0 w-100 flex flex-row items-center justify-center mt-1 mb-1'>
    <div className='bg-red-600 w-auto text-white text-sm font-semibold p-2'>
    NOTICE!!
    </div>
        <div className=' bg-slate-200  text-blue-700  p-1 w-full '>
          <marquee>This text will scroll from right to left</marquee>

        </div>
    </div>
    </>
  )
}
